import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Typography, Link } from '@material-ui/core';
import { toCapitalize, isOutOfScopeDuplicate } from '../../utils';
import userStyles from './styles';

const ListExistUsers = (props) => {
  const {
    id,
    leads,
    customers,
  } = props;

  const classes = userStyles();
  const { t } = useTranslation();
  const listLeads = (id ? leads.filter((item) => item.id !== id) : leads) || [];
  const listCustomers = (id ? customers.filter((item) => item.id !== id) : customers) || [];

  // LMS-5183: a duplicate outside the caller's scope comes back masked (no name, no access), so
  // it is listed as a plain label instead of a link the caller would be forbidden to open.
  const renderCustomer = (customer) => {
    if (isOutOfScopeDuplicate(customer)) {
      return (
        <span>
          {t('component.label.existing_customer_out_of_scope', 'Existing customer (outside your access)')}
        </span>
      );
    }
    return (
      <Link
        component={RouterLink}
        to={`/customers/${customer.id}`}
        target="_blank"
      >
        { toCapitalize(customer.name) }
      </Link>
    );
  };

  const renderSingleResult = () => {
    // Only match single lead
    if (listLeads.length === 1 && listCustomers.length === 0) {
      const lead = listLeads[0];
      return (
        <Link
          component={RouterLink}
          to={`/leads/${lead.id}`}
          target="_blank"
        >
          { toCapitalize(lead.name) }
        </Link>
      );
    }
    // Only match single customer
    if (listCustomers.length === 1 && listLeads.length === 0) {
      return renderCustomer(listCustomers[0]);
    }
    return '';
  };

  const haveSingleResult = (listLeads.length === 1 && listCustomers.length === 0)
    || (listCustomers.length === 1 && listLeads.length === 0);

  return (
    <div className={classes.container}>
      {
        haveSingleResult ? (
          <Typography>
            {t('component.label.are_you_looking_for', 'Are you looking for?')}
            &nbsp;
            { renderSingleResult() }
          </Typography>
        ) : (
          <>
            <Typography>{t('component.label.are_you_looking_for', 'Are you looking for?')}</Typography>
            <ul>
              {
                listLeads.map((lead) => (
                  <li key={lead.id}>
                    <Link
                      component={RouterLink}
                      to={`/leads/${lead.id}`}
                      target="_blank"
                    >
                      { toCapitalize(lead.name) }
                    </Link>
                  </li>
                ))
              }
              {
                listCustomers.map((customer) => (
                  <li key={customer.id}>
                    { renderCustomer(customer) }
                  </li>
                ))
              }
            </ul>
          </>
        )
      }
    </div>
  );
};

ListExistUsers.propTypes = {
  id: PropTypes.string,
  leads: PropTypes.arrayOf(
    PropTypes.instanceOf(Object),
  ),
  customers: PropTypes.arrayOf(
    PropTypes.instanceOf(Object),
  ),
};

ListExistUsers.defaultProps = {
  id: '',
  leads: [],
  customers: [],
};

export default ListExistUsers;
